import { render, staticRenderFns } from "./LogisticDashboard.vue?vue&type=template&id=f720d882&scoped=true&"
import script from "./LogisticDashboard.vue?vue&type=script&lang=js&"
export * from "./LogisticDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LogisticDashboard.vue?vue&type=style&index=0&id=f720d882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f720d882",
  null
  
)

export default component.exports